import React from "react";

export const LazyFeedTileHoverBridge = React.lazy(
    () => import(/* webpackChunkName: "Feed" */ "./FeedTileHover")
);
